import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

const Authentication = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const {
    loginWithRedirect,
    isLoading,
    isAuthenticated,
    error,
  } = useAuth0();

  const returnTo = location.state?.returnTo || "/";

  useEffect(() => {
    if (isLoading || error) {
      return;
    }

    if (isAuthenticated) {
      navigate(returnTo, { replace: true });
      return;
    }

    loginWithRedirect({
      appState: {
        returnTo,
      },
    }).catch(() => {
      // Auth0 error state is handled by useAuth0().
    });
  }, [
    isLoading,
    error,
    isAuthenticated,
    loginWithRedirect,
    navigate,
    returnTo,
  ]);

  const handleRetry = () => {
    loginWithRedirect({
      appState: {
        returnTo,
      },
    }).catch(() => {
      // Auth0 error state is handled by useAuth0().
    });
  };

  if (error) {
    return (
      <div className="h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-xl font-semibold mb-4">
            Authentication failed.
          </h2>

          <p className="mb-6">{error.message}</p>

          <button
            type="button"
            onClick={handleRetry}
            className="px-4 py-2 rounded"
          >
            Try again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="h-screen flex items-center justify-center">
      <p>Redirecting to login...</p>
    </div>
  );
};

export default Authentication;